import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import DataContainer from '../../../Shared/DataContainer';
import DropdownButton from '../../../Shared/DropdownButton';
import FileInput from '../../../Shared/FileInput';
import TextInput from '../../../Shared/TextInput';
import SelectInput from '../../../Shared/SelectInput';
import LoadingButton from '../../../Shared/LoadingButton';
import Icon from '../../../Shared/Icon';
import Pagination from '../../../Shared/Pagination';
import { can, toFormData } from '../../../utils';

const Index = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [searching, setSearching] = useState(false);
     const [openSearch, setOpenSearch] = useState(false);
     const [values, setValues] = useState({
          file: null,
          selectedLogo: '',
          name: data.filters.name || '',
          show_home: data.filters.show_home || '',
          is_online: data.filters.is_online || '',
          status: data.filters.status || '',
          paging: data.filters.paging || '',
          orderBy: data.filters.orderBy || ''
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleFileChange(file, path) {
          setValues(values => ({
               ...values,
               file: file,
               selectedLogo: path
          }));
     }

     function handleSubmitImport(e) {
          e.preventDefault();
          setSending(true);
          const formData = toFormData(values, 'POST');
          Inertia.post(route('product.import'), formData).then(() => {
               setSending(false);
          });
     }

     function toggleSearch(e) {
          e.preventDefault();
          setOpenSearch(!openSearch);
     }

     function handleSearch(e) {
          e.preventDefault();
          setSearching(true);
          const value = {
               name: values.name,
               show_home: values.show_home,
               is_online: values.is_online,
               orderBy: values.orderBy,
               status: values.status,
               paging: values.paging,
               orderBy: values.orderBy
          };
          Inertia.post(route('product.search'), value, {preserveState: false}).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Products</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Products</span>
               </div>
               <DataContainer>
                    <div className="col-span-12">
                         {can(auth.user, 'create-product')?<InertiaLink href={route('product.create')} className="bg-gray-300 hover:bg-gray-400 mr-2 text-gray-800 text-sm py-1 px-1 rounded inline-flex items-center">
                              <Icon name={'plus'} className={'fill-current w-4 h-4 mr-2'} />
                              Add Product
                         </InertiaLink>:null}
                         <InertiaLink onClick={e=>toggleSearch(e)} href={route('')} className="bg-gray-300 hover:bg-gray-400 mr-2 text-gray-800 text-sm py-1 px-1 rounded inline-flex items-center">
                              <Icon name={'search'} className={'fill-current w-4 h-4 mr-2'} />
                              Search
                         </InertiaLink>
                         <InertiaLink href={route('product.index')} className={`text-gray-500 hover:underline text-sm inline-flex items-center`}>
                              Clear
                         </InertiaLink>
                         <div className="flex float-right">
                              <form onSubmit={handleSubmitImport} className="flex justify-item-center item-center">
                                   <FileInput
                                        className=""
                                        label="Select File"
                                        name="file"
                                        accept=".csv,.xls,.xlsx"
                                        errors={errors.file}
                                        value={values.file}
                                        onChange={handleFileChange}
                                   />
                                   <LoadingButton type="submit" loading={sending} className="inline-flex items-center p-2 bg-gray-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring-gray disabled:opacity-25 transition ease-in-out duration-150 ml-2">
                                        Import
                                   </LoadingButton>
                              </form>
                         </div>
                    </div>
                    <div className={`col-span-12 border p-2 rounded bg-gray-100 ${openSearch?'block':'hidden'}`}>
                         <h2 className="text-md font-semibold text-gray-700">Search</h2>
                         <form className="w-full" onSubmit={handleSearch}>
                              <div className="grid grid-cols-3 gap-2">
                                   <TextInput
                                        className="form-input rounded-md shadow-sm block"
                                        label="Product Name or Code"
                                        name="name"
                                        type="text"
                                        disable={false}
                                        readonly={false}
                                        must={false}
                                        errors={errors.name}
                                        value={values.name}
                                        onChange={handleChange}
                                   />
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Show Home"
                                        name="show_home"
                                        must={false}
                                        errors={errors.show_home}
                                        value={values.show_home}
                                        onChange={handleChange}
                                   >
                                        <option value="">Select Option</option>
                                        <option key={`sup_show1`} value={true}>Show Home Page</option>
                                        <option key={`sup_show2`} value={false}>Not Show Home Page</option>
                                   </SelectInput>
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Available Online"
                                        name="is_online"
                                        must={false}
                                        errors={errors.is_online}
                                        value={values.is_online}
                                        onChange={handleChange}
                                   >
                                        <option value="">Select Option</option>
                                        <option key={`cat_ol1`} value={true}>Available Online</option>
                                        <option key={`cat_ol2`} value={false}>Not Available Online</option>
                                   </SelectInput>
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Status"
                                        name="status"
                                        must={false}
                                        errors={errors.status}
                                        value={values.status}
                                        onChange={handleChange}
                                   >
                                        <option value="">Select Option</option>
                                        <option key={`cat_st1`} value={true}>Active</option>
                                        <option key={`cat_st2`} value={false}>Inactive</option>
                                   </SelectInput>
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Order By"
                                        name="orderBy"
                                        must={false}
                                        errors={errors.orderBy}
                                        value={values.orderBy}
                                        onChange={handleChange}
                                   >
                                        <option value="">Order Result By</option>
                                        {data.order.map((order, i)=>{
                                             return <option key={`ordby${i}`} value={order}>{order}</option>
                                        })}
                                   </SelectInput>
                                   <SelectInput
                                        className="inline-block relative"
                                        label="Quanity per Page"
                                        name="paging"
                                        must={false}
                                        errors={errors.paging}
                                        value={values.paging}
                                        onChange={handleChange}
                                   >
                                        <option value="">Select Quantity per Page</option>
                                        {data.paginates.map((page, i)=>{
                                             return <option key={`pp${page}`} value={page}>{page}</option>
                                        })}
                                   </SelectInput>
                                   <div className="inline-block relative">
                                        <LoadingButton type="submit" loading={searching} className="w-full mt-5 text-center items-center px-4 py-3 bg-gray-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring-gray disabled:opacity-25 transition ease-in-out duration-150">
                                             Search
                                        </LoadingButton>
                                   </div>
                              </div>
                         </form>
                    </div>
                    <table className="table-fixed col-span-12 text-sm">
                         <thead className="bg-gray-400">
                              <tr>
                                   <th className="px-4 py-2">Name</th>
                                   {/* <th className="px-4 py-2">Category</th> */}
                                   <th className="px-4 py-2">Price</th>
                                   <th className="px-4 py-2">Qty Available</th>
                                   <th className="px-4 py-2">Show Home</th>
                                   <th className="px-4 py-2">Status</th>
                                   <th className="px-4 py-2">Ava. Online</th>
                                   <th className="px-4 py-2"></th>
                              </tr>
                         </thead>
                         <tbody>
                              {data.products.data.map(({id, name, code, type, currency, price, available, alert, show_home, is_online, status}) => {
                                   return <tr className={`${(available <= alert)?'bg-red-400':''}`} key={id}>
                                        <td className="border px-4 py-2">{name} <span className="text-sm text-gray-600">({code})</span></td>
                                        {/* <td className="border px-4 py-2 text-center">{category.join(', ')}</td> */}
                                        <td className="border px-4 py-2 text-right">{currency} {price.toFixed(2)}</td>
                                        <td className="border px-4 py-2 text-center">{available}</td>
                                        <td className="border px-4 py-2 text-center">{show_home?'Oui':'Non'}</td>
                                        <td className="border px-4 py-2 text-center">{status?'Active':'Inactive'}</td>
                                        <td className="border px-4 py-2 text-center">{is_online?'Oui':'Non'}</td>
                                        <td className="border px-4 py-2 text-center">
                                             <DropdownButton caption="Actions" color="blue">
                                                  {can(auth.user, 'read-product')?<InertiaLink href={route('product.show', id)} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'eye'} className={'fill-current w-5 h-5 mr-2'} /> View
                                                  </InertiaLink>:null}
                                                  {can(auth.user, 'update-product')?<InertiaLink href={route('product.edit', id)} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'edit'} className={'fill-current w-5 h-5 mr-2'} /> Edit
                                                  </InertiaLink>:null}
                                                  {can(auth.user, 'create-product')?<InertiaLink href={route('package.create', id)} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'plus'} className={'fill-current w-5 h-5 mr-2'} /> Add Items
                                                  </InertiaLink>:null}
                                             </DropdownButton>
                                        </td>
                                   </tr>
                              })}
                              {!data.products.data.length && (<tr>
                                   <td colSpan="7" className="p-4 bg-blue-100 text-blue-500 text-center">No data found.</td>
                              </tr>)}
                         </tbody>
                    </table>
                    <Pagination links={data.products.links} />
               </DataContainer>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Index.layout = page => <AdminLayout children={page} header={'Products'} />;

export default Index;
